import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import ClipLoader from 'react-spinners/ClipLoader'; // Spinner component

const Order = () => {
  const [orderId, setOrderId] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(''); // Error state for invalid credentials
  const navigate = useNavigate();

  const [cartCount, setCartCount] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous error
    setLoading(true); // Start loading spinner

    try {
      // API request to validate orderId and email
      const response = await axios.post(
        // 'http://localhost:3005/order/validate'
        'https://afric-fresh-backend.onrender.com/order/validate'
        
        , {
        orderId,
        email,
      });

      if (response.status === 200) {
        // On success, redirect to the order details page
        navigate(`/order-details/${orderId}`);
      }
    } catch (err) {
      // If there's an error, show an error message
      setError('Invalid Order ID or Email. Please try again.');
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} />
      <div className="container py-6 lg:mt-[70px] mt-[130px]">
        <div className="p-8 w-full">
          <h1 className="text-5xl font-semibold mb-4 text-left text-[#154F16]">Order Tracking</h1>
          <p className="text-gray-700 mb-6 text-left">
            To track your order please enter your Order ID in the box below and press the "Track" button. This was given to you on your receipt and in the confirmation email you should have received.
          </p>

          {error && <p className="text-red-500 mb-4">{error}</p>} {/* Error message */}

          <form className="flex justify-between max-sm:flex-col" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="order-id" className="block text-sm font-medium text-[#154F16]">Order ID</label>
              <input
                type="text"
                id="order-id"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                className="mt-1 block w-[390px] max-sm:w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Found in your order confirmation email."
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block max-sm:mt-5 text-sm font-medium text-[#154F16]">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-[390px] max-sm:w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Email you used during checkout."
                required
              />
            </div>
            <div className="mt-6 flex items-center">
              <button
                type="submit"
                className="w-[200px] h-[50px] py-2 px-4 bg-[#157c16] text-white rounded-md shadow-md hover:bg-[#155F16] focus:outline-none disabled:opacity-50"
                disabled={loading} // Disable button while loading
              >
                {loading ? <ClipLoader color="#fff" size={20} /> : 'Track'} {/* Show spinner or text */}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Order;